import React from 'react';
import { Root, StyledCard, Col, ImageBox, LogoArea } from './styled';

import style from './style.module.scss';

const LoginBaseContainer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Root>
      <div className={style.login_page__container}>
        <Col>
          <ImageBox />
          <LogoArea className={style.logo__wrapper}>
            <div className={style.logo} />
          </LogoArea>
        </Col>
        <StyledCard className={`card ${style.login__wrapper}`}>
          {children}
        </StyledCard>
      </div>
    </Root>
  );
};

export default LoginBaseContainer;
